import { parseGameKeyV2 } from '../../services/analyticsGameKey';
import { formatStartDateLocal, useMarketStore } from '../../stores/marketStore';

/** `YYYY-MM-DD` of the game a ticker belongs to, for a position/order label, or
 *  null when nothing has resolved the game (callers then keep the ticker's
 *  own date).
 *
 *  A ticker's date is NOT the game's date once the game moves: the TB/CLE
 *  parent moneyline kept its OCT17 ticker after postponement while its game
 *  (and its props' tickers) moved to 10-18, so a ticker-dated label read
 *  "10-17 · 2:08p" for a 10-18 start (#1254, docs/261018TrackerStartAndExpiry.md).
 *  Never join games by ticker date; this reads the store's identity joins only.
 *
 *  Precedence (the graph chip's, which this replaced):
 *    1. the resolved start (`getEventStartTimeMsByTicker`, joined by game
 *       identity) in the browser's local zone — the same day the board files
 *       the row under (`GameRow.date`), and the day of the local start time
 *       printed beside it;
 *    2. the canonical game key's date, only when no start has resolved (the
 *       label then shows "start —"). The board never reads this: it can be
 *       the UTC day for tennis, a day off the board's bucket. It is kept so a
 *       postponed game keyed to its new date reads that date before its start
 *       arrives;
 *    3. null. */
export function resolvedGameDate(ticker: string): string | null {
  const store = useMarketStore.getState();
  const mkt = store.getMarket(ticker);
  return (
    formatStartDateLocal(store.getEventStartTimeMsByTicker(ticker)) ??
    parseGameKeyV2(
      store.getGameKeyV2ForTicker(ticker) ?? mkt?.canonicalGameKeyV2 ?? mkt?.canonicalGameKey,
    )?.date ??
    null
  );
}
